import { UserService } from 'src/app/user/services/user.service';

import { PhoneNumberPipe } from '../../../../../shared/phoneNumber.pipe';
import { IsNilPipe } from 'src/app/pipes/is-nil.pipe';

import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  model,
  output,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import {
  MatCheckboxChange,
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { MatChipInputEvent, MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDivider } from '@angular/material/list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { AddEvent } from '../../models/add-event.interface';
import { RemoveEvent } from '../../models/remove-event.interface';
import { MatErrorMessagesDirective } from '@wettermanufaktur-gmbh/ui-sdk/directives/mat-error-messages';

export const MODULES = [
  CommonModule,
  ReactiveFormsModule,
  MatCardModule,
  MatFormFieldModule,
  MatInputModule,
  MatCheckboxModule,
  MatIconModule,
  MatButtonModule,
  MatTooltipModule,
  MatDatepickerModule,
  MatChipsModule,
  MatStepperModule,
  TranslateModule,
];
export const COMPONENTS = [FaIconComponent];
export const PIPES = [PhoneNumberPipe, IsNilPipe];
export const DIRECTIVES = [MatErrorMessagesDirective];

@Component({
  selector: 'app-users-tab-master-data',
  templateUrl: './users-tab-master-data.component.html',
  styleUrls: ['../../../../user-admin.component.scss'],
  imports: [...MODULES, ...COMPONENTS, ...PIPES, ...DIRECTIVES, MatDivider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersTabMasterDataComponent {
  newUser = input<boolean>();
  isEditingUserName = model<boolean>();
  deliveryTargetIcons = input<any>();
  deliveryTargets = input<any>();
  contingents = input<any>();
  separatorKeysCodes = input<number[]>();
  isSaving = input<boolean>();

  cancel = output();
  checkEmailToAddToDeliveryTargets = output();
  remove = output<RemoveEvent>();
  add = output<AddEvent>();
  autoDelivery = output<MatCheckboxChange>();
  doSubmit = output();
  summarizeUser = output();

  userService = inject(UserService);

  onCancel() {
    this.cancel.emit();
  }

  onCheckEmailToAddToDeliveryTargets() {
    this.checkEmailToAddToDeliveryTargets.emit();
  }

  onRemove(targetType: string, address: string) {
    this.remove.emit({ targetType, address });
  }

  onAdd(targetType: string, event: MatChipInputEvent) {
    this.add.emit({ targetType, event });
  }

  onAutoDelivery(event: MatCheckboxChange) {
    this.autoDelivery.emit(event);
  }

  onSubmit() {
    this.doSubmit.emit();
  }

  onSummarizeUser() {
    this.summarizeUser.emit();
  }

  onLog() {
    // TODO: remove this mthod, is not neccesary with matStepperNext
    const invalidControls = Object.entries(
      this.userService.formGroupStammdaten.controls
    )
      .filter(([_, c]) => c.invalid)
      .map(([name, c]) => ({
        name,
        status: c.status,
        errors: c.errors,
        value: c.value,
        touched: c.touched,
        dirty: c.dirty,
      }));

    console.log('Invalid controls:', invalidControls);
  }
}
